import TabbedPageShell from '@/components/TabbedPageShell';
import SelfEmployedTab from '@/components/work/SelfEmployedTab';
import RightsTab from '@/components/work/RightsTab';
import WorkJourneyCard from '@/components/work/WorkJourneyCard';
import SectionNudge from '@/components/SectionNudge';
import WorkToolsTab from '@/components/work/WorkToolsTab';
import SectionGuideRail from '@/components/playbooks/SectionGuideRail';

const TABS = [
  {
    key: 'rights',
    label: 'Employed',
    subtitle: 'Employment rights, contracts, and deadlines',
    content: <RightsTab />,
  },
  {
    key: 'self-employed',
    label: 'Self Employed',
    subtitle: 'HMRC, invoicing, deadlines',
    content: <SelfEmployedTab />,
  },
  {
    key: 'tools',
    label: 'Seeking Work',
    subtitle: 'Job-search packs, drafts, and next steps',
    content: <WorkToolsTab />,
  },
];

export default function WorkPage() {
  return (
    <TabbedPageShell
      title="My Work"
      subtitle="Employed, self-employed, and job-search support in one work home"
      tabs={TABS}
      nudge={<SectionNudge section="work" />}
      hero={<WorkJourneyCard />}
      guideRail={<SectionGuideRail section="work" />}
    />
  );
}
